import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Button, Divider, Menu, Spin, Tabs, Typography } from "antd";
import ReadDataTable from "../../Common/ReadDataTable";
import ActionHeader from "../../Common/ActionHeader";
import DeleteWarningModal from "../../Common/DeleteWarningModal";
import "../../Common/Form.css";
import UnitEdit from "../UnitEdit";
import { getUnit } from "../../../services/unitService";

const { Title } = Typography;

const UnitPage = (props) => {
  const [unit, setUnit] = useState({});
  const [formattedData, setFormattedData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState({
    error: false,
    message: "",
  });

  const formatData = (data) => {
    return {
      general: [
        {
          label: "Title:",
          text: data.title ? data.title : "",
        },
        {
          label: "Description:",
          text: data.description,
        },
      ],
    };
  };

  const renderSubunits = (subunits) => {
    if (subunits)
      return subunits.map((item) => {
          return (
              <Button shape="round" type="ghost" style={{ margin: "3px" }}>
                {`${item.code}`}
              </Button>
          );
      });
  };

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>Edit</Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const getData = () => {
    setIsLoading(true);
    getUnit({ code: props.match.params.unitId })
      .then((response) => {
        if (response.data.length !== 0) {
          const unit = response.data.unit;
          let data = formatData(unit);
          setUnit(unit);
          setFormattedData(data);
        } else {
          throw Error("This course offer does not exist!");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [props.match.params.unitId]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
          }}
        >
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: "50px", textAlign: "center" }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <>
          <DeleteWarningModal
            isVisible={isDeleteModalVisible}
            setIsVisible={setIsDeleteModalVisible}
            deleteLink={`${process.env.REACT_APP_BACKEND_URL}/`}
            params={{}}
          />

          <UnitEdit
            isOpen={isEditModalVisible}
            toggle={() => setIsEditModalVisible(false)}
            unit={unit}
          />

          <ActionHeader title={unit.description} actionMenu={actionMenu} />

          {formattedData.general ? (
            <section className="grey-section">
              <Title level={5}>Details</Title>
              <ReadDataTable items={formattedData.general} />

              <Divider />
              {unit.subunits ? (
                <div>
                  <Title level={5}>Subunits</Title>
                  {renderSubunits(unit.subunits)}
                </div>
              ) : null}
              <Divider />
              
            </section>
          ) : null}
        </>
      )}
    </div>
  );
};

export default withRouter(UnitPage);
